// filepath: /Users/dev/Desktop/projects/farmciti-frontend/src/pages/blog/WPPostsPage.jsx
import React, { useEffect, useState } from "react";
import FarmCardStyle from "../../../assets/stylesheets/FarmCard.module.css";
import Logger from "../../../utils/logger";
import FamilyMain from "../../../assets/img/blog/familyMain.webp";
import MarketMain from "../../../assets/img/blog/marketMain.webp";
import VancouverMain from "../../../assets/img/blog/vancouver-main.webp";
import LavenderMain from "../../../assets/img/blog/lavender/MainLavender.webp"; 
import SkeletonCard from "../../../components/common/SkeletonCard";
import MainQC from "../../../assets/img/blog/qc/mapleSyrup03.webp"; 
import MainON from "../../../assets/img/blog/on/wheeler04.webp"; 


const log = Logger.create("WPPostsPage");

export default function WPPostsPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Simulate loading delay for Cards
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // Local hardcoded entries to appear first in the list
  const Cards = [
      {
      id: "best-maple-syrup-farms-ontario",
      link: "/blog/best-maple-syrup-farms-ontario",
      image: MainON,
      title: "Best Maple Syrup Farms in Ontario (2026 Guide)"
    },
    {
      id: "best-maple-syrup-farms-quebec",
      link: "/blog/best-maple-syrup-farms-quebec",
      image: MainQC,
      title: "Best Maple Syrup Farms in Quebec (2026 Guide)"
    },
    {
      id: "best5-christmas-markets-near-vancouver",
      link: "/blog/best5-christmas-markets-near-vancouver",
      image: VancouverMain,
      title: "Best 5 Christmas Markets near Vancouver 2025"
    },
    {
      id: "best5-christmas-markets-near-toronto",
      title: "Best 5 Christmas Markets near Toronto 2025",
      link: "/blog/best5-christmas-markets-near-toronto",
      image: MarketMain,
    }
  ];
 

  return (
    <section className={FarmCardStyle["events-section"]}>
      <div className={FarmCardStyle["events-container"]}>
        <div className={FarmCardStyle["events-header"]}>
          <div>
            <h2 className={FarmCardStyle["events-title"]}>What We're Talking About</h2>
            <p className={FarmCardStyle["events-subtitle"]}>
              From how-to's to hidden gems – find your next farm idea here
            </p>
          </div>
        </div>

        <div className={FarmCardStyle["events-carousel-wrapper"]}>
          {/* Desktop: Grid layout, Mobile: Horizontal scroll */}
          <div className={FarmCardStyle["blog-card-grid"]}>

            {loading ? (
              <>
                {[1, 2, 3, 4].map((i) => (
                  <SkeletonCard key={`skeleton-${i}`} variant="blog" />
                ))}
              </>
            ) : (
              <>
                {/* Always show the hardcoded cards first */}
                {Cards.map((card) => (
                  <article key={card.id} className={FarmCardStyle["blog-card"]}>
                    <div className={FarmCardStyle["event-card-image-container"]}>
                      <a href={card.link}>
                        <img
                          src={card.image}
                          alt={card.title}
                          className={FarmCardStyle["event-card-image"]}
                          loading="lazy"
                        />
                      </a>
                    </div>
                    <h3 className={FarmCardStyle["event-card-title"]}>
                      <a href={card.link} style={{ textDecoration: "none", color: "inherit" }}>
                        {card.title}
                      </a>
                    </h3>
                  </article>
                ))}

                {!error && posts.map((post) => (
                  <article key={post.id} className={FarmCardStyle["blog-card"]}>
                    <div className={FarmCardStyle["event-card-image-container"]}>
                      <a href={post.link} target="_blank" rel="noopener noreferrer">
                        <img
                          src={post.image}
                          alt={post.title}
                          className={FarmCardStyle["event-card-image"]}
                          loading="lazy"
                        />
                      </a>
                    </div>
                    <h3 className={FarmCardStyle["event-card-title"]}>
                      <a href={post.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
                        <span dangerouslySetInnerHTML={{ __html: post.title }} />
                      </a>
                    </h3>
                  </article>
                ))}
              </>
            )}

            {error && (
              <div style={{ color: "crimson" }}>Failed to load posts. Please try again later.</div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
